import { render, staticRenderFns } from "./MultiplierWarning.vue?vue&type=template&id=5a782fd2"
import script from "./MultiplierWarning.vue?vue&type=script&lang=ts"
export * from "./MultiplierWarning.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports